import {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export interface EntityListLinkProps {
  path: string;
  label?: string;
  target?: "_self" | "_blank";
  rel?: string;
  className?: string;
}

export const EntityListLink = ({
  path,
  label,
  target = "_self",
  rel,
  className,
}: EntityListLinkProps) => {
  const { t } = useTranslation();
  const resolvedLabel =
    label ??
    (target === "_blank"
      ? t("entityListLink.openInNewTab")
      : t("entityListLink.open"));

  const link = (
    <Link
      to={path}
      target={target}
      rel={rel ?? (target === "_blank" ? "noreferrer noopener" : undefined)}
    >
      <Button variant="ghost" size="icon" type="button" className={className}>
        <ExternalLink className="w-4 h-4" />
      </Button>
    </Link>
  );

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{link}</TooltipTrigger>
        <TooltipContent>{resolvedLabel}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
